import { CodeBlock } from "@mittwald/flow-remote-react-components";
import { Link } from "@mittwald/flow-remote-react-components";
import { Text } from "@mittwald/flow-remote-react-components";
import {
  defaultErrorComponentMap,
  ErrorMap,
  getSupportEmail,
} from "@wiesinghilker/extension-lib-frontend";

const SupportEmailLink = ({ error }: { error: Error }) => {
  const supportEmail = getSupportEmail();
  return (
    <Link
      href={`mailto:${supportEmail}?subject=${encodeURIComponent("Fehler in der Extension")}&body=${encodeURIComponent(`Folgender Fehler ist bei der Benutzung der Extension aufgetreten:\n\n${error.stack ?? error.message}\n\nDer Fehler ist auf folgender Seite aufgetreten:\n\n${window.location.href}`)}`}
    >
      {supportEmail}
    </Link>
  );
};

export const errorMap: ErrorMap = {
  ...defaultErrorComponentMap,
  UpdateImageCompressionSettingsError: (error: Error) => (
    <>
      <Text>
        Wir konnten deine Bildkomprimierung-Einstellungen nicht speichern.
        Folgende Fehlermeldung wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Bitte überprüfe, ob du aus dieser Fehlermeldung das Problem ableiten
        kannst. Falls nicht, wende dich bitte an unseren Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
  LoadProjectError: (error: Error) => (
    <>
      <Text>
        Wir konnten dein Projekt nicht aus dem mStudio abrufen. Folgende
        Fehlermeldung wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Möglicherweise handelt es sich dabei nur um ein temporäres Problem.
        Probiere es einfach in einigen Augenblicken nochmal.
      </Text>
      <Link href={window.location.href}>Nochmal versuchen</Link>
      <Text>
        Wenn sich das Problem nicht von selbst lösen lässt, wende dich bitte an
        unseren Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
  LoadImageCompressionSettingsError: (error: Error) => (
    <>
      <Text>
        Wir konnten die Bildkomprimierung-Einstellungen deiner App nicht laden.
        Folgende Fehlermeldung wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Möglicherweise handelt es sich dabei nur um ein temporäres Problem.
        Probiere es einfach in einigen Augenblicken nochmal.
      </Text>
      <Link href={window.location.href}>Nochmal versuchen</Link>
      <Text>
        Wenn sich das Problem nicht lösen lässt, wende dich bitte an unseren
        Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
};
